export const reportsEn = {
  // Report Scheduler (FC2-2486)
  REPORT_SCHEDULER: 'Report Scheduler',
  REPORT_SCHEDULER_DESCRIPTION: 'Schedule app reports to be emailed automatically.',
  CREATE_REPORT_SCHEDULE: 'Create Schedule',
  EDIT_REPORT_SCHEDULE: 'Edit Schedule',
  VIEW_REPORT_SCHEDULE: 'View Schedule',
  DELETE_REPORT_SCHEDULE: 'Delete Schedule',
  DELETE_REPORT_SCHEDULE_CONFIRMATION: 'Are you sure you want to delete this schedule?',
  DELETE_REPORT_SCHEDULE_CONFIRMATION_NAMED: 'Are you sure you want to permanently delete the "{0}" schedule?',
  REPORT_SCHEDULE_NAME: 'Schedule Name',
  TARGET_REPORT: 'Target Report',
  SCHEDULE_FREQUENCY: 'Frequency',
  DESTINATION_EMAILS: 'Destination Emails',
  DESTINATION_EMAILS_HELP: 'Comma-separated email addresses.',
  LAST_SENT: 'Last Sent',
  FREQUENCY_DAILY: 'Daily',
  FREQUENCY_WEEKLY: 'Weekly',
  FREQUENCY_MONTHLY: 'Monthly',
  REPORT_SCHEDULE_CREATED_SUCCESSFULLY: 'Report schedule created successfully',
  REPORT_SCHEDULE_UPDATED_SUCCESSFULLY: 'Report schedule updated successfully',
  REPORT_SCHEDULE_DELETED_SUCCESSFULLY: 'Report schedule deleted successfully',
  MAX_REPORT_SCHEDULES_REACHED: 'You have reached the maximum of 10 schedules.',
  SCHEDULES_CREATED_COUNT: 'Created {0}/{1} schedules',
  REPORT_SCHEDULE_EMAILS_REQUIRED: 'Add at least one recipient email.',
  SAVE: 'Save',
  WHAT_TO_SEND: 'What to Send',
  WHEN_AND_WHO: 'When and Who',
  SEND_TIME: 'Send Time',
  SCHEDULE_DAY: 'Day',
  RECIPIENTS: 'Recipients',
  ADD_EMAIL_PLACEHOLDER: 'Add email…',
  NEXT_RUN: 'Next Run',
  ESTIMATED_DELIVERY: 'Estimated delivery around {0} (factor time)',
  DATE_SCOPE_ASOF: 'The report is dated as of the day it runs (factor time).',
  DATE_SCOPE_SETTLEMENT_PREFIX: 'Sent on the scheduled date (factor time).',
  DATE_SCOPE_RANGE_DAILY: 'Covers the previous day by the selected filter type.',
  DATE_SCOPE_RANGE_WEEKLY: 'Covers the previous week (Mon–Sun) by the selected filter type.',
  DATE_SCOPE_RANGE_MONTHLY: 'Covers the previous month by the selected filter type.',
  DAY_MONDAY: 'Monday',
  DAY_TUESDAY: 'Tuesday',
  DAY_WEDNESDAY: 'Wednesday',
  DAY_THURSDAY: 'Thursday',
  DAY_FRIDAY: 'Friday',
  DAY_SATURDAY: 'Saturday',
  DAY_SUNDAY: 'Sunday',
  MONTHLY_DAY_FIRST: 'First day',
  MONTHLY_DAY_FIFTEENTH: '15th',
  MONTHLY_DAY_LAST: 'Last day',
  SETTLEMENT_FILTER_INVOICE_DATE: 'Invoice Date',
  SETTLEMENT_FILTER_PAYMENT_DATE: 'Payment Date',
  SETTLEMENT_FILTER_CLOSED_DATE: 'Closed Date',
  // Debtor Concentration Report
  CONCENTRATION_REPORT: 'Debtor Concentration Report',
  CONCENTRATION_DATE_VIEW_RECORDS: 'To display results, choose an as-of date.',
  ERROR_GET_CONCENTRATION_REPORT:
    'It is not possible to obtain the concentration report information. Please try again later.',
  DEBTOR_ID: 'Debtor ID',
  DEBTOR_NAME: 'Debtor Name',
  DEBTOR_AR_BALANCE: 'Debtor AR Balance',
  CLIENT_ID: 'Client ID',
  CLIENT_NAME: 'Client Name',
  CLIENT_AR_BALANCE: 'Client AR Balance',
  CREDIT_LIMIT: 'Credit Limit',
  DEBTOR_CREDIT_LIMIT: 'Debtor Credit Limit',
  AVG_DAYS_TO_PAY: 'Average Days to Pay',
  DEBTOR_AVG_DAYS_TO_PAY: 'Debtor Avg Days to Pay',
  CONCENTRATION: 'Concentration',
  REPORTS: 'Reports',
  BETA: 'Beta',
  REPORTS_WORKSPACE_TITLE: 'Reports Workspace',
  REPORTS_WORKSPACE_SUBTITLE:
    'Browse reports faster with search and quick filters. Use Beta reports for validation before they become final.',
  TOTAL_REPORTS: 'Total Reports',
  APP_REPORTS: 'App Reports',
  SUPERSET_REPORTS: 'Superset Reports',
  REPORTS_FILTER_ALL: 'All',
  REPORTS_FILTER_APP: 'App',
  REPORTS_FILTER_SUPERSET: 'Superset',
  SEARCH_REPORTS_PLACEHOLDER: 'Search by report name',
  OPEN_REPORT: 'Open Report',
  LOADING_REPORTS: 'Loading reports...',
  NO_REPORTS_FOUND: 'No reports match your filters',
  NO_REPORTS_FOUND_SUBTITLE: 'Try a different search term or switch the report type filter.',
  BETA_REPORTS_TITLE: 'Beta Reports',
  BETA_REPORTS_SUBTITLE:
    'Beta reports should be used for review and evaluation purposes only and should not be relied upon for financial, compliance, or audit decisions until marked as final.',
  DOWNLOAD_REPORT: 'Download Report',
  RECEIVABLES_AGING: 'Receivables Aging',
  FEES: 'Fees',
  AVAILABLE_FOR_RELEASE: 'Available for Release',
  //STAR MICHAEL
  SALES_COMMISSION_REPORT: 'Sales Commission Report',
  SELECT_FILTER_VIEW_RECORD: 'Select the filters to view the record',
  SELECT_DATE_AND_SALES_EXECUTIVE_FILTER:
    'To display results, choose a date range and select at least one sales executive.',
  SELECT_DATE_VIEW_RECORD: 'To display results, choose a date range.',
  AGING_BY_DEBTOR_REPORT: 'Aging By Debtor Report',
  NO_DATA_SELECT_FILTERS_AGING_REPORT:
    'If you do not see data, please select the end date up to which you wish to retrieve the information. This date is required to generate the corresponding reports.',
  CLIENTS_PER_PAGE: 'Clients per page',
  DEBTORS_PER_PAGE: 'Debtors per page',
  AGED_1_TO_30: '1-30 Aged',
  AGED_31_TO_60: '31-60 Aged',
  AGED_61_TO_90: '61-90 Aged',
  AGED_91_TO_120: '91-120 Aged',
  AGED_120_PLUS: '120+ Aged',
  INVOICE_BALANCE: 'Invoice Balance',
  CLIENT_TOTALS: 'Client Totals',
  EMAILS_TO_SEND_REPORT: 'Emails to send report',
  EMAIL_LENGHT_MUST_BE_LESS_EQUALS_50: 'Email length must be less than or equal to 50 characters',
  EMAIL_ALREADY_EXISTS_ON_LIST: 'Email already exists on the list',
  LEDGERS_REPORT: 'Ledgers Report',
  CLIENT_CONCENTRATION_REPORT: 'Client Concentration Report',
  CLIENT_CONCENTRATION: 'Client Concentration',
  DEBTOR_CONCENTRATION: 'Debtor Concentration',
  CONCENTRATION_PERCENTAGE: 'Concentration Percentage',
  CONCENTRATION_PERCENTAGE_TOOLTIP:
    'Represents the percentage that this debtor’s concentration accounts for relative to the total client concentration.',
  CLIENT_CONCENTRATION_TOP_10: 'Client Concentration Top 10',
  CLIENT_CONCENTRATION_GENERAL: 'Client Concentration General',
  TOP_10_CONCENTRATION: 'Top 10 Concentration',
  TOP_DEBTOR: 'Top Debtor',
  EXPORT_TOP_10: 'Export Top 10',
  AGING_SUMMARY: 'Aging Summary',
  INVOICE_DUE_AMOUNT: 'Invoice Due Amount',
  PERCENTAGE: 'Percentage',
  INVOICE_COUNT: 'Invoice Count',
  AGING_BUCKET: 'Aging Bucket',
  PERFORMANCE_SUMMARY: 'Performance Summary',
  INVOICES_PURCHASED: 'Invoices Purchased',
  NET_ADVANCES: 'Net Advances',
  ADVANCE_DISCOUNTS: 'Advance Discounts',
  RECEIVED_DISCOUNTS: 'Received Discounts',
  TOTAL_RECEIPTS: 'Total Receipts',
  TOTAL_CHARGEBACKS: 'Total Chargebacks',
  INELIGIBLE_DISPUTED_TOTAL: 'Ineligible Disputed Total',
  PORTFOLIO_PERFORMANCE_REPORT: 'Portfolio Performance Report',
  //END MICHAEL

  //STAR FABIAN
  SETTLEMENT_DATE_VIEW_RECORDS: 'To display results, choose a date range and select a filter type.',
  AS_OF_DATE: 'As of date',
  FILTER_TYPE: 'Filter type',
  SETTLEMENT_REPORT: 'Settlement Report',
  ERROR_GET_REPORT: 'It is not possible to obtain the report information. Please try again later.',
  PAID_ON_DATE: 'Payment Date',
  CLIENT_SUMMARY_DATE_VIEW_RECORDS: 'To display results, choose a date range',
  STARTING_AR_BALANCE: 'Starting AR Balance',
  ENDING_AR_BALANCE: 'Ending AR Balance',
  FUNDED_AR: 'Funded AR',
  OOS_INVOICES: 'OOS Invoices',
  NF_INVOICES: 'NF Invoices',
  COLLECTED_AR: 'Collected AR',
  NF_COLLECTED: 'NF Collected',
  OOS_COLLECTED: 'OOS Collected',
  OVERPAYMENTS: 'Overpayments',
  TOTAL_COLLECTED: 'Total Collected',
  CLIENT_SUMMARY: 'Client Summary',
  CLIENT_FEE_REPORT: 'Client Fee Report',
  FACTORING_FEES: 'Factoring Fees',
  INTEREST_FEES: 'Interest Fees',
  COLLECTION_FEES: 'Collection Fees',
  PAYMENT_FEES: 'Payment Fees',
  NEGATIVE_CASH_RESERVE_FEES: 'Negative Cash Reserve Fees',
  FUEL_ADVANCE_FEE: 'Fuel Advance Fee',
  RESERVE_RELEASE_FEE: 'Reserve Release Fee',
  TOTAL_FEES: 'Total Fees',
  ACCRUED_INTEREST_FEES: 'Accrued Interest Fees',
  ACCRUED_COLLECTION_FEES: 'Accrued Collection Fees',
  TOTAL_ACCRUED_FEES: 'Total Accrued Fees',
  AR_CHANGES: 'AR Changes',
  INTEREST_REPORT: 'Interest Report',
  PRINCIPAL_AMOUNT: 'Principal Amount',
  RATE_INTEREST_RATE: 'Rate',
  DAILY_ACCRUAL: 'Daily Accrual',
  INTEREST_REPORT_VIEW_RECORDS: 'To display the results, select a date range and a client.',
  FINANCIAL_TOTALS_REPORT: 'Financial Totals Report',
  FINANCIAL_TOTALS_DATE_VIEW_RECORDS: 'To display results, choose a date range and enter a report type.',
  PERIOD: 'Period',
  FUNDED_INVOICES: 'Funded Invoices',
  CLOSE_INVOICES: 'Closed Invoices',
  INVOICE_TOTAL: 'Invoice Total',
  ADVANCE_TOTAL: 'Advance Total',
  REPORT_TYPE: 'View Type',
  ROI_REPORT: 'ROI Report',
  ROI_SELECT_DATE_VIEW_RECORD: 'To display results, select at least an end date.',
  REPORT_EMAIL_SENT_SUCCESS: "Report's email was sent successfully",
  ERROR_EXPORT_REPORT: 'Failed to send report email. Please try again.',
  COMPANY_FEES: 'Company Level Fees',
  COMPANY_FEES_TOOLTIP: 'Includes the following fee types:',
  COMPANY_FEE_NEGATIVE_INTEREST: 'Negative Interest Fee',
  COMPANY_FEE_ADDITIONAL: 'Additional Fee',
  COMPANY_FEE_OVER_ADVANCE: 'Over Advance Fee',
  COMPANY_FEE_PAYMENT: 'Payment Fees',
  COMPANY_FEE_AUTOCHARGE_INTEREST: 'Autocharge Interest Cash Reserve',
  COMPANY_FEE_RESERVE_RELEASE: 'Reserve Release Fee',
  COMPANY_FEE_RESERVE_RELEASE_DISBURSEMENT: 'Reserve Release Disbursement Fee',
  TOTAL_FEES_TOOLTIP_INVOICE: 'Invoice Fees',
  TOTAL_FEES_TOOLTIP_COMPANY: 'Company Level Fees',
  ADVANCE_PERCENTAGE: 'Advance %',
  ADVANCE: 'Advance',
  PURCHASE_FEE_PERCENTAGE: 'Purchase Fee %',
  FEE_PERCENTAGE: 'Fee %',
  INVOICE_ROI: 'Invoice ROI',
  ANNUAL_ROI: 'Annual ROI',
  ON_ACCOUNT_PAYMENT_REPORT: 'On Account Payment',
  ON_ACCOUNT_PAYMENT_DATE_VIEW_RECORDS: 'To display results, choose an as-of date.',
  COMMISSION_PARTNER_REPORT: 'Referral Partner Commission Report',
  COMMISSION_PARTNER_FEE_TOTAL: 'Fee Total',
  COMMISSION_PARTNER_TOTAL_COMMISSION: 'Total Commission',
  COMMISSION_EARNED: 'Commission Earned',
  COMMISSION_PARTNER_COMMISSION_BREAKDOWN: 'Commission Breakdown',
  COMMISSION_PARTNER_COMMISSION_SUBTOTAL: 'Commission Subtotal',
  COMMISSION_PARTNER_FINAL_PAYABLE_COMMISSION: 'Final Payable Commission',
  BASE_COMMISSION: 'Base Commission',
  GRAND_TOTAL: 'Grand Total',
  SHARE: 'Share',
  //END FABIAN

  CASH_RESERVE_BALANCE: 'Cash Reserve Balance',
  ESCROW_RESERVE_BALANCE: 'Escrow Reserve Balance',
  TOTAL_RESERVES: 'Total Reserves',
  ESCROW_RESERVES: 'Escrow Reserves',
  INELIGIBLE_DISPUTED: 'Ineligible/Disputed',
  ACCRUED_FEES: 'Accrued Fees',
  ACCRUED_INTEREST: 'Accrued Interest',
  CLIENT_AR_AGING_BUCKETS_REPORT: 'Client AR Aging Buckets Report',
  OUTSTANDING_1_TO_30: '1-30 days outstanding',
  OUTSTANDING_31_TO_60: '31-60 days outstanding',
  OUTSTANDING_61_TO_90: '61-90 days outstanding',
  OUTSTANDING_91_TO_120: '91-120 days outstanding',
  OUTSTANDING_121_PLUS: '121+ days outstanding',
  CLIENT_COLLATERAL_REPORT: 'Client Collateral Report',
  TOTAL_AR: 'Total AR',
  INELIGIBLE: 'Ineligible',
  DISPUTED: 'Disputed',
  TOTAL: 'Total',

  // START PATRICIO
  COLLATERAL_TREND: 'Collateral Trend',
  // END PATRICIO

  // START ESTEBAN
  OPEN_FUEL_ADVANCES: 'Open Fuel Advances',
  CLOSED_FUEL_ADVANCES: 'Closed Fuel Advances',
  // END ESTEBAN
}

export const reportsEs: typeof reportsEn = {
  // Report Scheduler (FC2-2486)
  REPORT_SCHEDULER: 'Programador de Reportes',
  REPORT_SCHEDULER_DESCRIPTION: 'Programá el envío automático de reportes por email.',
  CREATE_REPORT_SCHEDULE: 'Crear Programación',
  EDIT_REPORT_SCHEDULE: 'Editar Programación',
  VIEW_REPORT_SCHEDULE: 'Ver Programación',
  DELETE_REPORT_SCHEDULE: 'Eliminar Programación',
  DELETE_REPORT_SCHEDULE_CONFIRMATION: '¿Seguro que querés eliminar esta programación?',
  DELETE_REPORT_SCHEDULE_CONFIRMATION_NAMED: '¿Seguro que querés eliminar permanentemente la programación de "{0}"?',
  REPORT_SCHEDULE_NAME: 'Nombre',
  TARGET_REPORT: 'Reporte',
  SCHEDULE_FREQUENCY: 'Frecuencia',
  DESTINATION_EMAILS: 'Emails de Destino',
  DESTINATION_EMAILS_HELP: 'Direcciones de email separadas por coma.',
  LAST_SENT: 'Último Envío',
  FREQUENCY_DAILY: 'Diaria',
  FREQUENCY_WEEKLY: 'Semanal',
  FREQUENCY_MONTHLY: 'Mensual',
  REPORT_SCHEDULE_CREATED_SUCCESSFULLY: 'Programación creada correctamente',
  REPORT_SCHEDULE_UPDATED_SUCCESSFULLY: 'Programación actualizada correctamente',
  REPORT_SCHEDULE_DELETED_SUCCESSFULLY: 'Programación eliminada correctamente',
  MAX_REPORT_SCHEDULES_REACHED: 'Alcanzaste el máximo de 10 programaciones.',
  SCHEDULES_CREATED_COUNT: 'Creadas {0}/{1} programaciones',
  REPORT_SCHEDULE_EMAILS_REQUIRED: 'Agregá al menos un email de destino.',
  SAVE: 'Guardar',
  WHAT_TO_SEND: 'Qué Enviar',
  WHEN_AND_WHO: 'Cuándo y a Quién',
  SEND_TIME: 'Hora de Envío',
  SCHEDULE_DAY: 'Día',
  RECIPIENTS: 'Destinatarios',
  ADD_EMAIL_PLACEHOLDER: 'Agregar email…',
  NEXT_RUN: 'Próximo Envío',
  ESTIMATED_DELIVERY: 'Envío estimado alrededor de {0} (hora del factor)',
  DATE_SCOPE_ASOF: 'El reporte se genera con fecha del día en que corre (hora del factor).',
  DATE_SCOPE_SETTLEMENT_PREFIX: 'Se envía en la fecha programada (hora del factor).',
  DATE_SCOPE_RANGE_DAILY: 'Incluye el día anterior según el tipo de filtro seleccionado.',
  DATE_SCOPE_RANGE_WEEKLY: 'Incluye la semana anterior (lun–dom) según el tipo de filtro seleccionado.',
  DATE_SCOPE_RANGE_MONTHLY: 'Incluye el mes anterior según el tipo de filtro seleccionado.',
  DAY_MONDAY: 'Lunes',
  DAY_TUESDAY: 'Martes',
  DAY_WEDNESDAY: 'Miércoles',
  DAY_THURSDAY: 'Jueves',
  DAY_FRIDAY: 'Viernes',
  DAY_SATURDAY: 'Sábado',
  DAY_SUNDAY: 'Domingo',
  MONTHLY_DAY_FIRST: 'Primer día',
  MONTHLY_DAY_FIFTEENTH: 'Día 15',
  MONTHLY_DAY_LAST: 'Último día',
  SETTLEMENT_FILTER_INVOICE_DATE: 'Fecha de Factura',
  SETTLEMENT_FILTER_PAYMENT_DATE: 'Fecha de Pago',
  SETTLEMENT_FILTER_CLOSED_DATE: 'Fecha de Cierre',
  // Debtor Concentration Report
  CONCENTRATION_REPORT: 'Informe de concentración de deudores',
  CONCENTRATION_DATE_VIEW_RECORDS: 'Para mostrar resultados, elija una fecha de corte.',
  ERROR_GET_CONCENTRATION_REPORT:
    'No es posible obtener la información del informe de concentración. Por favor, inténtelo de nuevo más tarde.',
  DEBTOR_ID: 'ID de Deudor',
  DEBTOR_NAME: 'Nombre del Deudor',
  DEBTOR_AR_BALANCE: 'Saldo AR del Deudor',
  CLIENT_ID: 'ID de Cliente',
  CLIENT_NAME: 'Nombre del Cliente',
  CLIENT_AR_BALANCE: 'Saldo AR del Cliente',
  CREDIT_LIMIT: 'Límite de Crédito',
  DEBTOR_CREDIT_LIMIT: 'Límite de Crédito del Deudor',
  AVG_DAYS_TO_PAY: 'Días promedio de pago',
  DEBTOR_AVG_DAYS_TO_PAY: 'Días promedio de pago del deudor',
  CONCENTRATION: 'Concentración',
  REPORTS: 'Informes',
  BETA: 'Beta',
  REPORTS_WORKSPACE_TITLE: 'Panel de Reportes',
  REPORTS_WORKSPACE_SUBTITLE:
    'Explora reportes más rápido con búsqueda y filtros rápidos. Usa los reportes Beta para validación antes de que queden finales.',
  TOTAL_REPORTS: 'Total Reportes',
  APP_REPORTS: 'Reportes App',
  SUPERSET_REPORTS: 'Reportes Superset',
  REPORTS_FILTER_ALL: 'Todos',
  REPORTS_FILTER_APP: 'App',
  REPORTS_FILTER_SUPERSET: 'Superset',
  SEARCH_REPORTS_PLACEHOLDER: 'Buscar por nombre del reporte',
  OPEN_REPORT: 'Abrir Reporte',
  LOADING_REPORTS: 'Cargando reportes...',
  NO_REPORTS_FOUND: 'No hay reportes que coincidan con tus filtros',
  NO_REPORTS_FOUND_SUBTITLE: 'Prueba con otra búsqueda o cambia el filtro de tipo de reporte.',
  BETA_REPORTS_TITLE: 'Reportes Beta',
  BETA_REPORTS_SUBTITLE:
    'Los reportes beta deben usarse solo para revisión y evaluación, y no deben utilizarse para decisiones financieras, de cumplimiento o de auditoría hasta que estén marcados como finales.',
  DOWNLOAD_REPORT: 'Descargar Informe',
  RECEIVABLES_AGING: 'Antigüedad de los créditos',
  FEES: 'Tarifas',
  AVAILABLE_FOR_RELEASE: 'Disponible para liberar',
  //STAR MICHAEL
  SALES_COMMISSION_REPORT: 'Informe de comisiones de ventas',
  SELECT_FILTER_VIEW_RECORD: 'Seleccione los filtros para ver el registro',
  SELECT_DATE_AND_SALES_EXECUTIVE_FILTER:
    'Para mostrar resultados, elija un rango de fechas y seleccione al menos un ejecutivo de ventas.',
  SELECT_DATE_VIEW_RECORD: 'Para mostrar resultados, elija un rango de fechas.',
  AGING_BY_DEBTOR_REPORT: 'Informe de antigüedad por deudor',
  NO_DATA_SELECT_FILTERS_AGING_REPORT:
    'Si no ve datos, seleccione la fecha de finalización hasta la cual desea recuperar la información. Esta fecha es necesaria para generar los reportes correspondientes.',
  CLIENTS_PER_PAGE: 'Clientes por página',
  DEBTORS_PER_PAGE: 'Deudores por página',
  AGED_1_TO_30: '1-30 Días',
  AGED_31_TO_60: '31-60 Días',
  AGED_61_TO_90: '61-90 Días',
  AGED_91_TO_120: '91-120 Días',
  AGED_120_PLUS: '120+ Días',
  INVOICE_BALANCE: 'Saldo de Factura',
  CLIENT_TOTALS: 'Totales del cliente',
  EMAILS_TO_SEND_REPORT: 'Correos electrónicos para enviar informe',
  EMAIL_LENGHT_MUST_BE_LESS_EQUALS_50: 'La longitud del correo electrónico debe ser menor o igual a 50 caracteres',
  EMAIL_ALREADY_EXISTS_ON_LIST: 'El correo electrónico ya existe en la lista',
  LEDGERS_REPORT: 'Informe de libros contables',
  CLIENT_CONCENTRATION_REPORT: 'Informe de concentración de clientes',
  CLIENT_CONCENTRATION: 'Concentración de clientes',
  DEBTOR_CONCENTRATION: 'Concentración de deudores',
  CONCENTRATION_PERCENTAGE: 'Porcentaje de concentración',
  CONCENTRATION_PERCENTAGE_TOOLTIP:
    'Representa el porcentaje que la concentración de este deudor representa en relación con la concentración total del cliente.',
  CLIENT_CONCENTRATION_TOP_10: 'Top 10 de concentración de clientes',
  CLIENT_CONCENTRATION_GENERAL: 'Concentración general de clientes',
  TOP_10_CONCENTRATION: 'Concentración Top 10',
  TOP_DEBTOR: 'Deudor principal',
  EXPORT_TOP_10: 'Exportar Top 10',
  AGING_SUMMARY: 'Resumen de Antigüedad',
  INVOICE_DUE_AMOUNT: 'Monto Vencido de Factura',
  PERCENTAGE: 'Porcentaje',
  INVOICE_COUNT: 'Cantidad de Facturas',
  AGING_BUCKET: 'Rango de Antigüedad',
  PERFORMANCE_SUMMARY: 'Resumen de rendimiento',
  INVOICES_PURCHASED: 'Facturas compradas',
  NET_ADVANCES: 'Adelantos netos',
  ADVANCE_DISCOUNTS: 'Descuentos de adelanto',
  RECEIVED_DISCOUNTS: 'Descuentos recibidos',
  TOTAL_RECEIPTS: 'Recibos totales',
  TOTAL_CHARGEBACKS: 'Contracargos totales',
  INELIGIBLE_DISPUTED_TOTAL: 'Total no elegible/en disputa',
  PORTFOLIO_PERFORMANCE_REPORT: 'Informe de rendimiento de cartera',
  //END MICHAEL

  //STAR FABIAN
  SETTLEMENT_DATE_VIEW_RECORDS: 'Para mostrar resultados, elija un rango de fechas y seleccione un tipo de filtro.',
  AS_OF_DATE: 'A la fecha',
  FILTER_TYPE: 'Tipo de filtro',
  SETTLEMENT_REPORT: 'Informe de liquidación',
  ERROR_GET_REPORT: 'No es posible obtener la información del informe. Por favor, inténtelo de nuevo más tarde.',
  PAID_ON_DATE: 'Fecha de Pago',
  CLIENT_SUMMARY_DATE_VIEW_RECORDS: 'Para mostrar resultados, elija un rango de fechas',
  STARTING_AR_BALANCE: 'Saldo inicial de AR',
  ENDING_AR_BALANCE: 'Saldo final de AR',
  FUNDED_AR: 'AR financiado',
  OOS_INVOICES: 'Facturas OOS',
  NF_INVOICES: 'Facturas NF',
  COLLECTED_AR: 'AR cobrado',
  NF_COLLECTED: 'Cobrado NF',
  OOS_COLLECTED: 'Cobrado OOS',
  OVERPAYMENTS: 'Sobrepagos',
  TOTAL_COLLECTED: 'Total cobrado',
  CLIENT_SUMMARY: 'Resumen del cliente',
  CLIENT_FEE_REPORT: 'Informe de Honorarios del Cliente',
  FACTORING_FEES: 'Hon. Factorización',
  INTEREST_FEES: 'Hon. Interés',
  COLLECTION_FEES: 'Hon. Cobranza',
  PAYMENT_FEES: 'Hon. Pagos',
  NEGATIVE_CASH_RESERVE_FEES: 'Hon. Res. Efectivo Neg.',
  FUEL_ADVANCE_FEE: 'Hon. Adel. Combustible',
  RESERVE_RELEASE_FEE: 'Hon. Lib. Reserva',
  TOTAL_FEES: 'Total Honorarios',
  ACCRUED_INTEREST_FEES: 'Hon. Int. Devengados',
  ACCRUED_COLLECTION_FEES: 'Hon. Cobr. Devengados',
  TOTAL_ACCRUED_FEES: 'Total Hon. Devengados',
  AR_CHANGES: 'Cambios en AR',
  INTEREST_REPORT: 'Informe de intereses',
  PRINCIPAL_AMOUNT: 'Monto principal',
  RATE_INTEREST_RATE: 'Tasa de interés',
  DAILY_ACCRUAL: 'Acumulación diaria',
  INTEREST_REPORT_VIEW_RECORDS: 'Para mostrar los resultados, seleccione un rango de fechas y un cliente.',
  FINANCIAL_TOTALS_REPORT: 'Informe de Totales Financieros',
  FINANCIAL_TOTALS_DATE_VIEW_RECORDS: 'Para mostrar resultados, elija un rango de fechas e ingrese un tipo de reporte.',
  PERIOD: 'Período',
  FUNDED_INVOICES: 'Facturas Financiadas',
  CLOSE_INVOICES: 'Facturas Cerradas',
  INVOICE_TOTAL: 'Total de Facturas',
  ADVANCE_TOTAL: 'Total de Adelantos',
  REPORT_TYPE: 'Tipo de vista',
  ROI_REPORT: 'Informe ROI',
  ROI_SELECT_DATE_VIEW_RECORD: 'Para mostrar resultados, seleccione al menos una fecha de fin.',
  REPORT_EMAIL_SENT_SUCCESS: 'El correo del reporte fue enviado exitosamente',
  ERROR_EXPORT_REPORT: 'Error al enviar el correo del reporte. Por favor, inténtelo de nuevo.',
  COMPANY_FEES: 'Honorarios a Nivel Compañía',
  COMPANY_FEES_TOOLTIP: 'Incluye los siguientes tipos de honorarios:',
  COMPANY_FEE_NEGATIVE_INTEREST: 'Honorario de Interés Negativo',
  COMPANY_FEE_ADDITIONAL: 'Honorario Adicional',
  COMPANY_FEE_OVER_ADVANCE: 'Honorario de Sobre Adelanto',
  COMPANY_FEE_PAYMENT: 'Honorarios de Pago',
  COMPANY_FEE_AUTOCHARGE_INTEREST: 'Cargo Automático de Reserva de Interés',
  COMPANY_FEE_RESERVE_RELEASE: 'Honorario de Liberación de Reserva',
  COMPANY_FEE_RESERVE_RELEASE_DISBURSEMENT: 'Honorario de Desembolso de Liberación de Reserva',
  TOTAL_FEES_TOOLTIP_INVOICE: 'Honorarios de Factura',
  TOTAL_FEES_TOOLTIP_COMPANY: 'Honorarios a Nivel Compañía',
  ADVANCE_PERCENTAGE: 'Adelanto %',
  ADVANCE: 'Adelanto',
  PURCHASE_FEE_PERCENTAGE: 'Tarifa de compra %',
  FEE_PERCENTAGE: 'Tarifa %',
  INVOICE_ROI: 'ROI de Factura',
  ANNUAL_ROI: 'ROI Anual',
  ON_ACCOUNT_PAYMENT_REPORT: 'Pagos On Account',
  ON_ACCOUNT_PAYMENT_DATE_VIEW_RECORDS: 'Para mostrar resultados, elija una fecha de corte.',
  COMMISSION_PARTNER_REPORT: 'Informe de comisiones de socios de referencia',
  COMMISSION_PARTNER_FEE_TOTAL: 'Total de Tarifas',
  COMMISSION_PARTNER_TOTAL_COMMISSION: 'Comisión Total',
  COMMISSION_EARNED: 'Comisión Ganada',
  COMMISSION_PARTNER_COMMISSION_BREAKDOWN: 'Desglose de Comisión',
  COMMISSION_PARTNER_COMMISSION_SUBTOTAL: 'Subtotal de comisión',
  COMMISSION_PARTNER_FINAL_PAYABLE_COMMISSION: 'Comisión Final Pagable',
  BASE_COMMISSION: 'Comisión base',
  GRAND_TOTAL: 'Total General',
  SHARE: 'Participación',
  //END FABIAN

  CASH_RESERVE_BALANCE: 'Saldo de reserva en efectivo',
  ESCROW_RESERVE_BALANCE: 'Saldo de reserva en fideicomiso',
  TOTAL_RESERVES: 'Reservas totales',
  ESCROW_RESERVES: 'Reservas en fideicomiso',
  INELIGIBLE_DISPUTED: 'No elegible / En disputa',
  ACCRUED_FEES: 'Honorarios devengados',
  ACCRUED_INTEREST: 'Intereses devengados',
  CLIENT_AR_AGING_BUCKETS_REPORT: 'Informe de Envejecimiento de CxC por Cliente',
  OUTSTANDING_1_TO_30: '1-30 días pendiente',
  OUTSTANDING_31_TO_60: '31-60 días pendiente',
  OUTSTANDING_61_TO_90: '61-90 días pendiente',
  OUTSTANDING_91_TO_120: '91-120 días pendiente',
  OUTSTANDING_121_PLUS: '121+ días pendiente',
  CLIENT_COLLATERAL_REPORT: 'Informe de Garantías del Cliente',
  TOTAL_AR: 'AR Total',
  INELIGIBLE: 'No elegible',
  DISPUTED: 'En disputa',
  TOTAL: 'Total',

  // START PATRICIO
  COLLATERAL_TREND: 'Tendencia de colateral',
  // END PATRICIO

  // START ESTEBAN
  OPEN_FUEL_ADVANCES: 'Adelantos de combustible abiertos',
  CLOSED_FUEL_ADVANCES: 'Adelantos de combustible cerrados',
  // END ESTEBAN
}
